<script>
    import app from "../stores/app";
    import user from "../stores/user";
    import {
        PAYMENT_TYPE,
        PAYMENT_TYPES,
        OBJECT_TYPE
    } from "../lib/constants";
    import Notifier from "../stores/notifier";
    import {copyObject, setFocusTo, sort} from "../lib/lib";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PriceControl from "../components/controls/PriceControl.svelte";

    export let accounts;
    export let departments;
    export let transfer;
    export let commissions;

    let old = '';
    let totalCommissions = 0;
    let priceRemain = 0;

    let paymentTypes = [];
    Object.keys(PAYMENT_TYPE).map(key => {
        paymentTypes.push({
            id: PAYMENT_TYPE[key],
            name: PAYMENT_TYPES[PAYMENT_TYPE[key]]
        });
    });

    const addCompanyTransporter = () => {
        let obj = commissions.find(x => x.object_id == $app.settings.transporter_id && x.object_type == OBJECT_TYPE.TRANSPORTER && x.is_custom == 1);
        if (obj) {
            Notifier.showError("Transport company already in commissions!");
            setFocusTo(`commission-${$app.settings.transporter_id}`);
            return;
        }

        commissions = [...commissions, {
            key: `${OBJECT_TYPE.TRANSPORTER}-${$app.settings.transporter_id}`,
            object_type: OBJECT_TYPE.TRANSPORTER,
            object_id: $app.settings.transporter_id,
            name: $app.settings.transporter.name,
            price: null,
            is_custom: 1,
            view_index: 1000
        }];
        setFocusTo(`commission-${$app.settings.transporter_id}`);
    }

    // initialize commissions
    if (commissions) {
        // set commission keys
        commissions.map(item => {
            item.key = `${item.object_type}-${item.object_id}`;
        });
    }

    $: {
        let hash = transfer.account_id + transfer.department_id + transfer.payment_type + JSON.stringify(transfer.vehicles);

        if (old != hash) {
            let obj;
            let view_index = 0;
            // check if account exist in commissions
            let account = accounts.find(x => x.id == transfer.account_id);
            if (account) {
                obj = commissions.find(x => (x.object_id == transfer.account_id && x.object_type == OBJECT_TYPE.ACCOUNT));
                if (!obj) {
                    commissions = [...commissions, {
                        key: `${OBJECT_TYPE.ACCOUNT}-${account.id}`,
                        object_type: OBJECT_TYPE.ACCOUNT,
                        object_id: account.id,
                        name: account.name,
                        price: null,
                        info: 'Account',
                        is_custom: 0,
                        view_index,
                    }];
                } else {
                    obj.name = account.name;
                    obj.info = 'Account';
                    obj.view_index = view_index;
                }
            }

            // check if department exist in commissions
            view_index++;
            let department = departments.find(x => x.id == transfer.department_id);
            if (department) {
                obj = commissions.find(x => x.object_id == transfer.department_id && x.object_type == OBJECT_TYPE.DEPARTMENT);
                if (!obj) {
                    commissions = [...commissions, {
                        key: `${OBJECT_TYPE.DEPARTMENT}-${department.id}`,
                        object_type: OBJECT_TYPE.DEPARTMENT,
                        object_id: department.id,
                        name: department.name,
                        price: null,
                        info: 'Department',
                        is_custom: 0,
                        view_index,
                    }];
                } else {
                    obj.name = department.name;
                    obj.info = 'Department';
                    obj.view_index = view_index;
                }
            }

            // check for transporters
            transfer.vehicles.map(item => {
                if (item.transporter_id > 0) {
                    view_index++;
                    obj = commissions.find(x => x.object_id == item.transporter_id && x.object_type == OBJECT_TYPE.TRANSPORTER && x.vehicle_id == item.vehicle.id);
                    if (!obj) {
                        commissions = [...commissions, {
                            key: `${OBJECT_TYPE.TRANSPORTER}-${item.transporter_id}`,
                            object_type: OBJECT_TYPE.TRANSPORTER,
                            object_id: item.transporter_id,
                            vehicle_id: item.vehicle.id,
                            name: item.transporter_name,
                            price: null,
                            info: `Transporter: ${app.vehicleTypeName(item.vehicle_type_id)}`,
                            is_custom: 0,
                            view_index
                        }];
                    } else {
                        obj.name = item.transporter_name;
                        obj.info = `Transporter: ${app.vehicleTypeName(item.vehicle_type_id)}`;
                        obj.view_index = view_index;
                    }
                }
            });

            // remove unused objects from commissions
            let data = copyObject(commissions);
            data.map(item => {
                if (item.object_type === OBJECT_TYPE.ACCOUNT && item.object_id !== transfer.account_id) {
                    commissions = commissions.filter(x => x.key !== `${OBJECT_TYPE.ACCOUNT}-${item.object_id}`);
                } else if (item.object_type === OBJECT_TYPE.DEPARTMENT && item.object_id !== transfer.department_id) {
                    commissions = commissions.filter(x => x.key !== `${OBJECT_TYPE.DEPARTMENT}-${item.object_id}`);
                } else if (item.object_type === OBJECT_TYPE.TRANSPORTER && item.is_custom === 0) {
                    // check if transporter exist in vehicles
                    let vehicle = transfer.vehicles.find(x => x.transporter_id === item.object_id);
                    if (!vehicle) {
                        commissions = commissions.filter(x => x.key !== `${OBJECT_TYPE.TRANSPORTER}-${item.object_id}`);
                    }
                }
            });

            // remove undefined commissions
            // due to last version bug
            commissions = commissions.filter(x => x.name);
            old = hash;
            sort(commissions, 'view_index');
            commissions = commissions;
        }

        totalCommissions = 0;
        commissions.map(item => {
            totalCommissions += item.price > 0 ? parseFloat(item.price) : 0;
        });
        priceRemain = parseFloat(transfer.price) - totalCommissions;
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading">
        Price
    </div>
    <div class="panel-body panel-pad">
        <div class="form-group">
            <label>Means of payment</label>
            <select class="form-select" bind:value="{ transfer.payment_type }">
                {#each paymentTypes as item}
                    <option value="{ item.id }">{ item.name }</option>
                {/each}
            </select>
        </div>

        <!--        <div class="row">-->
        <!--            <div class="col">-->
        <!--                <div class="form-group">-->
        <!--                    <label>Cost</label>-->
        <!--                    <div class="commission-price">-->
        <!--                        <PriceControl bind:value="{ transfer.price }"/>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->

        <div class="row">
            <div class="col-md-4 col-12 form-group">
                <label>Cost</label>
                <PriceControl bind:value="{ transfer.price }" placeholder="€"/>
            </div>
            {#if Number(transfer.payment) > 0}
                <div class="col-md-4 col-12 form-group">
                    <label>Payment</label>
                    <input type="text" class="form-control" value={transfer.payment} readonly/>
                </div>
            {/if}
        </div>

        {#if user.isAdmin()}
            <legend class="mb-0">
                <h6 class="mb-0">Commissions</h6>
                {#if $app.settings.transporter_id}
                    <button class="btn btn-primary btn-xs btn-flex" on:click="{ addCompanyTransporter }">
                        <AppIcon icon="plus-circle" size="16" strokeWidth="2" left/>
                        { $app.settings.transporter.name }
                    </button>
                {/if}
            </legend>
            <table class="table table-list">
                <tbody>
                {#each commissions as item}
                    <tr>
                        <td class="ps-0">
                            {#if item.info}
                                <div class="small">
                                    { item.info }
                                </div>
                            {/if}
                            { item.name }
                            <!--{ item.view_index }-->
                            <!--{ item.key }-->
                        </td>
                        <td class="price-column p-0 ps-1">
                            <PriceControl bind:value="{ item.price }" cssClass="minimal"
                                          id="commission-{ item.object_id }"/>
                        </td>
                    </tr>
                {/each}
                <tr>
                    <td class="text-gray ps-0">Total</td>
                    <td class="p-0 ps-1">
                        <div class="form-control fw-bold border-none">
                            { totalCommissions.toFixed(2) }
                        </div>
                    </td>
                </tr>
                {#if transfer.price > 0 && priceRemain != 0}
                    <tr>
                        <td class="text-gray ps-0">Remain</td>
                        <td class="p-0 ps-1">
                            <div class="form-control text-danger border-none" class:fw-bold={ priceRemain < 0 }>
                                { priceRemain.toFixed(2) }
                            </div>
                        </td>
                    </tr>
                {/if}
                </tbody>
            </table>
            {#if totalCommissions > transfer.price}
                <div class="alert alert-danger p-2 mt-2 mb-0">
                    Commissions are greater than the transfer price!
                </div>
            {/if}
        {/if}
    </div>
</div>
<!--<style>-->
<!--    .commission-price {-->
<!--        max-width: 150px;-->
<!--    }-->
<!--</style>-->